"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingBalanceLogInfo = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const info_1 = require("./info");
const links_1 = require("./links");
require("./index.scss");
exports.className = 'accounting-balance-log-info';
const AccountingBalanceLogInfo = (props) => {
    const { balance, changeAmount, onClickOverview, modificators, overviewPdfLoading, balanceInfoHidden, transactionOverviewHidden, } = props;
    if (balanceInfoHidden && transactionOverviewHidden)
        return null;
    const classNames = (0, classFunctions_1.getClassNames)(exports.className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(info_1.AccountingBalanceInfo, { balance: balance, changeAmount: changeAmount, hidden: balanceInfoHidden }),
        react_1.default.createElement(links_1.AccountingBalanceLogInfoLinks, { onClickOverview: onClickOverview, overviewPdfLoading: overviewPdfLoading, hidden: transactionOverviewHidden })));
};
exports.AccountingBalanceLogInfo = AccountingBalanceLogInfo;
//# sourceMappingURL=index.js.map